import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import StudentDoubtsComponent from "../components/studentdoubts/StudentDoubtsComponent";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { Container } from "react-bootstrap";
import { isBrowser } from "react-device-detect";

class StudentDoubts extends Component {
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };

  // Deep link target: /student-doubts?doubtId=123 (dashboard "View Details") opens
  // the Doubts Inbox on that doubt. Router state is accepted too, for callers that
  // push a location object instead of a URL.
  getInitialDoubtId = () => {
    const { location } = this.props;
    if (!location) return null;
    if (location.state && location.state.doubtId) return location.state.doubtId;
    return new URLSearchParams(location.search || "").get("doubtId");
  };

  render() {
    if (Cookies.get("token") == undefined) this.props.history.push("/login");
    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <div
            id="sidebar"
            className={
              isBrowser == true
                ? "sidebar-menu d-none d-xl-block d-lg-block"
                : "sidebar-menu d-block d-xl-none d-lg-none"
            }
          >
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0">
            <Container fluid>
              <StudentDoubtsComponent initialDoubtId={this.getInitialDoubtId()} />
            </Container>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default StudentDoubts;
